document.addEventListener('DOMContentLoaded', function () {
  var header = document.getElementById('hr-site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('hr-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var revealEls = document.querySelectorAll('.hr-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hr-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('hr-in'); });
  }

  /* Accordion — used by the product buy box and the FAQ section */
  document.querySelectorAll('.hr-accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.hr-accordion-item');
      var panel = item.querySelector('.hr-accordion-panel');
      var wasOpen = item.classList.contains('is-open');

      if (item.dataset.group) {
        document.querySelectorAll('.hr-accordion-item[data-group="' + item.dataset.group + '"]').forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove('is-open');
            sibling.querySelector('.hr-accordion-panel').style.maxHeight = null;
            sibling.querySelector('.hr-accordion-trigger').setAttribute('aria-expanded', 'false');
          }
        });
      }

      item.classList.toggle('is-open', !wasOpen);
      trigger.setAttribute('aria-expanded', String(!wasOpen));
      panel.style.maxHeight = wasOpen ? null : panel.scrollHeight + 'px';
    });
  });

  /* Off-canvas filter drawer — used by the collection page */
  var filterToggle = document.querySelector('[data-hr-filter-toggle]');
  var filterPanel = document.querySelector('.hr-filters');
  var filterBackdrop = document.querySelector('.hr-filters-backdrop');
  var filterClose = document.querySelector('.hr-filters-close button');

  function openFilters() {
    if (filterPanel) filterPanel.classList.add('is-open');
    if (filterBackdrop) filterBackdrop.classList.add('is-open');
  }
  function closeFilters() {
    if (filterPanel) filterPanel.classList.remove('is-open');
    if (filterBackdrop) filterBackdrop.classList.remove('is-open');
  }
  if (filterToggle) filterToggle.addEventListener('click', openFilters);
  if (filterClose) filterClose.addEventListener('click', closeFilters);
  if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilters);

  /* Cart quantity steppers — used by the cart page */
  document.querySelectorAll('[data-hr-cart-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.nextElementSibling;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
    });
  });
  document.querySelectorAll('[data-hr-cart-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.previousElementSibling;
      input.value = (parseInt(input.value, 10) || 0) + 1;
    });
  });

  /* Sort-by select — used by the collection page */
  var sortSelect = document.querySelector('[data-hr-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
});
